import { Component } from "@angular/core";
import { SettingsService } from "src/app/_services/settings.service";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-uber-token",
  templateUrl: "./uber-token.component.html",
  styleUrls: ["./uber-token.component.scss"],
})
export class UberTokenComponent {
  session = "";
  isSubmitting = false;

  constructor(
    private settingsService: SettingsService,
    private toastrService: ToastrService
  ) {}

  get canSubmit(): boolean {
    return !this.isSubmitting && !!this.session.trim();
  }

  activateToken(): void {
    const session = (this.session || "").trim();
    if (!session || this.isSubmitting) {
      return;
    }

    this.isSubmitting = true;
    this.settingsService.activateUberSourceToken(session).subscribe(
      () => {
        this.isSubmitting = false;
        this.session = "";
        this.toastrService.success("Token activated", "");
      },
      (error) => {
        this.isSubmitting = false;
        const message =
          error?.error?.message ||
          error?.error?.messageText ||
          "Failed to activate Uber token";
        this.toastrService.error(message, "");
      }
    );
  }
}
